            <!-- Водители низ -->
<div class="tabpage drivers hidden" id="drivers_bottom">
  <div class="blockheader">{{'Driver information'|translate }}</div>
    <div class="tablewrap">
      <div class="table">
        <table>
          <tr><td>{{'Driver'|translate }}</td>            <td><span id="drivername"></span></td></tr>
          <tr><td>{{'Internal ID'|translate }}</td>       <td><span id="internalid"></span></td></tr>
          <tr><td>{{'Phone №'|translate }}</td>           <td><span id="driverphone"></span></td></tr>
          <tr><td>{{'Driver licence'|translate }}</td>    <td><span id="driverlic"></span></td></tr>
          <tr><td>{{'Category'|translate }}</td>          <td><span id="drivercat"></span></td></tr>
          <tr><td>{{'Class'|translate }}</td>             <td><span id="driverclass"></span></td></tr>
          <tr><td>{{'Rating'|translate }}</td>            <td><span id="driverrating"></span></td></tr>
        </table>
        <table *ngIf="showDeviceInfo" id="pointinfotable">
          <tr>
            <td class="caption" colspan="4">
              <img id="markericon" />
              <div>
                <span id="markername"></span>
                <span id="markercomment"></span>
              </div>
            </td>
          </tr>
          <tr><td colspan="2">{{'Time'|translate }}</td><td colspan="2"><span id="markertime"></span></td></tr>
          <tr><td colspan="2">{{'Coordinates'|translate }}</td><td colspan="2"><span id="markercoord"></span></td></tr>
          <tr><td colspan="2">{{'Speed'|translate }}</td><td colspan="2"><span id="markerspeed"></span></td></tr>
          <tr><td colspan="2">{{'Satellites'|translate }}</td><td colspan="2"><span id="markersat"></span></td></tr>
        </table>
      </div>
    </div>
</div>
